import React, { FC } from "react";
import { IconType } from "./types";

export const InfoCircleIcon: FC<IconType> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
  >
    <path
      d="M9.99984 13.8333V10.5M9.99984 7.16668H10.0082M18.3332 10.5C18.3332 15.1024 14.6022 18.8333 9.99984 18.8333C5.39746 18.8333 1.6665 15.1024 1.6665 10.5C1.6665 5.89764 5.39746 2.16668 9.99984 2.16668C14.6022 2.16668 18.3332 5.89764 18.3332 10.5Z"
      stroke="#BBBBBB"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
